import React, { useEffect } from 'react';
import withRouter from '../.././components/withRouter';
import { exitImpersonate } from '../../api/userApi';

const ExitImpersonation = (props: any) => {
    useEffect(() => {
        exitImpersonate().then((res) => {
            if (res && res.access_token && res.refresh_token) {
                localStorage.setItem('access_token', res.access_token);
                localStorage.setItem('refresh_token', res.refresh_token);

                window.location.replace('/user');
            }
        });
    }, []);

    return (<React.Fragment>
    </React.Fragment>
    );
};

export default withRouter(ExitImpersonation);